import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, vShow as _vShow, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex-lg-row-fluid mb-10 mb-lg-0 me-lg-7 me-xl-10" }
const _hoisted_2 = {
  class: "card pt-10 stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid",
  id: "penyediaanCalon",
  ref: "penyediaanCalon"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px\"><div class=\"stepper-nav ps-lg-10\"><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">1</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Kriteria Calon</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">2</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Pengesahan</h3><div class=\"stepper-desc\"></div></div></div></div></div>", 1)
const _hoisted_4 = { class: "flex-row-fluid py-lg-5 px-lg-15" }
const _hoisted_5 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_6 = { class: "w-100" }
const _hoisted_7 = { class: "row gx-10 mb-5" }
const _hoisted_8 = { class: "col-lg-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-gray-700 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Kemaskini Tetapan Kriteria")
], -1)
const _hoisted_10 = { class: "mt-4 mb-4" }
const _hoisted_11 = {
  class: "d-flex",
  style: {"align-items":"center"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "statusDropdown",
  class: "form-label me-2"
}, "Status:", -1)
const _hoisted_13 = { class: "col-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "AKTIF" }, "AKTIF", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "TIDAK AKTIF" }, "TIDAK AKTIF", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "BUKA" }, "BUKA", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "BARU" }, "BARU", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "SEMAKAN" }, "SEMAKAN", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "SELESAI" }, "SELESAI", -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-lg-6" }
const _hoisted_22 = ["checked"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10",
  for: "pemangkuan"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-center w-100" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder fs-4 mb-2" }, " Pemangkuan ")
  ])
], -1)
const _hoisted_24 = { class: "col-lg-6" }
const _hoisted_25 = ["checked"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "kenaikan"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-center w-100" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4" }, "Kenaikan Pangkat")
  ])
], -1)
const _hoisted_27 = { class: "mb-5" }
const _hoisted_28 = { class: "mb-2 fv-row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Skim Perkhidmatan & Gred", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: ""
}, " Sila Pilih Jenis Pemangkuan ", -1)
const _hoisted_31 = ["value"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: ""
}, " Sila Pilih Jenis Kenaikan Pangkat ", -1)
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = { class: "mb-2 fv-row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tarikh Lantikan / Tarikh Kenaikan Pangkat / Pemangkuan ", -1)
const _hoisted_37 = { class: "row d-flex" }
const _hoisted_38 = { class: "col-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tarikh Mula", -1)
const _hoisted_40 = { class: "col-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tarikh Akhir", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1)
const _hoisted_43 = { class: "mb-5" }
const _hoisted_44 = { class: "mb-2 fv-row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tarikh Tempoh Permohonan", -1)
const _hoisted_46 = { class: "row d-flex" }
const _hoisted_47 = { class: "col-6" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label tooltext" }, "Tarikh Mula", -1)
const _hoisted_49 = {
  key: 0,
  "data-bs-toggle": "tooltip",
  title: "Permohonan Pemangkuan Badan ikhtisas Terbuka Sepanjang Tahun."
}
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "col-6" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tarikh Akhir", -1)
const _hoisted_53 = {
  key: 0,
  "data-bs-toggle": "tooltip",
  title: "Permohonan Pemangkuan Badan ikhtisas Terbuka Sepanjang Tahun."
}
const _hoisted_54 = { key: 1 }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1)
const _hoisted_56 = { class: "mb-5" }
const _hoisted_57 = { class: "mb-2 fv-row" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Markah LNPT", -1)
const _hoisted_59 = { class: "row d-flex" }
const _hoisted_60 = { class: "col-6" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tahun Mula", -1)
const _hoisted_62 = { class: "col-6" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tahun Akhir", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1)
const _hoisted_65 = { class: "mb-4 d-flex justify-content-between mt-5" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Lokasi Penempatan Khas", -1)
const _hoisted_67 = { class: "form-check form-switch form-switch-lg form-check-custom form-check-solid" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label mx-2" }, "Tidak", -1)
const _hoisted_69 = ["disabled"]
const _hoisted_70 = {
  key: 1,
  class: "form-check-input",
  type: "checkbox",
  name: "sich",
  disabled: ""
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Ya", -1)
const _hoisted_72 = {
  key: 0,
  class: "bg-light-primary rounded border-primary border border-dashed p-6"
}
const _hoisted_73 = { class: "col-lg-12 mb-2" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-5 me-2" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fv-row" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Negeri")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fv-row" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Daerah")
    ])
  ])
], -1)
const _hoisted_75 = { class: "col-lg-5 me-2" }
const _hoisted_76 = ["onUpdate:modelValue"]
const _hoisted_77 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Sila pilih negeri", -1)
const _hoisted_78 = ["value"]
const _hoisted_79 = { class: "col-lg-5 me-2" }
const _hoisted_80 = {
  key: 0,
  class: "col-lg-2"
}
const _hoisted_81 = ["onClick"]
const _hoisted_82 = {
  key: 0,
  class: "d-flex",
  style: {"display":"none"}
}
const _hoisted_83 = { class: "col-lg-5 me-2" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Sila pilih negeri", -1)
const _hoisted_85 = ["value"]
const _hoisted_86 = { class: "col-lg-5" }
const _hoisted_87 = { class: "input-group mb-3" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", {
  class: "input-group-append",
  style: {"position":"absolute","right":"10px","top":"50%","transform":"translateY(-50%)"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down" })
  ])
], -1)
const _hoisted_89 = { class: "dropdown-menu show" }
const _hoisted_90 = ["onClick"]
const _hoisted_91 = {
  class: "d-flex mt-5",
  style: {"display":"none"}
}
const _hoisted_92 = { class: "mt-4 mb-4 d-flex justify-content-between" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Hantar notifikasi kepada calon apabila Permohonan dibuka", -1)
const _hoisted_94 = { class: "form-check form-switch form-switch-lg form-check-custom form-check-solid" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label mx-2" }, "Tidak", -1)
const _hoisted_96 = ["disabled"]
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Ya", -1)
const _hoisted_98 = { "data-kt-stepper-element": "content" }
const _hoisted_99 = { class: "w-100" }
const _hoisted_100 = { class: "row gx-10 mb-5" }
const _hoisted_101 = { class: "col-lg-12" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-gray-700 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "PENGESAHAN")
], -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tajuk Siri Kenaikan Pangkat / Pemangkuan", -1)
const _hoisted_105 = { class: "row mt-3 h-40px" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Kenaikan Pangkat bagi / Pemangkuan:")
], -1)
const _hoisted_107 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_108 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_110 = { class: "row mt-3 h-40px" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tarikh Tempoh Lantikan / Kenaikan Pangkat / Pemangkuan:")
], -1)
const _hoisted_112 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_113 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_115 = { class: "row mt-3 h-40px" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Bilangan Pegawai Layak:")
], -1)
const _hoisted_117 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_118 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#senarai_pegawai",
  class: "btn btn-success mx-2"
}, " Senarai ", -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_121 = { class: "row mt-3 h-40px" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tempoh Permohonan:")
], -1)
const _hoisted_123 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_124 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_126 = { class: "row mt-3 h-40px" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Markah LNPT:")
], -1)
const _hoisted_128 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_129 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_131 = { class: "row mt-3 h-40px" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Lokasi Penempatan Khas:")
], -1)
const _hoisted_133 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_134 = {
  key: 0,
  class: "fw-bolder fs-6 text-dark"
}
const _hoisted_135 = {
  key: 1,
  class: "fw-bolder fs-6 text-dark"
}
const _hoisted_136 = {
  key: 0,
  class: "row mt-3 bg-light-warning rounded border-warning border border-dashed p-6"
}
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 mb-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-dark" }, "Negeri")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 mb-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-dark" }, "Daerah")
  ])
], -1)
const _hoisted_138 = { class: "d-flex justify-content-between" }
const _hoisted_139 = { class: "col-lg-6 mb-2" }
const _hoisted_140 = { class: "col-lg-6 mb-2" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_142 = { class: "row mt-3 h-40px" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Hantar notifikasi kepada calon apabila Permohonan dibuka:")
], -1)
const _hoisted_144 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_145 = {
  key: 0,
  class: "fw-bolder fs-6 text-dark"
}
const _hoisted_146 = {
  key: 1,
  class: "fw-bolder fs-6 text-dark"
}
const _hoisted_147 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_148 = { class: "d-flex flex-stack pt-15" }
const _hoisted_149 = { class: "me-2" }
const _hoisted_150 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_151 = { class: "indicator-label" }
const _hoisted_152 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Sila Tunggu... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_154 = { class: "svg-icon svg-icon-3 ms-1 me-0" }
const _hoisted_155 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_156 = { class: "modal-dialog modal-dialog-centered mw-950px" }
const _hoisted_157 = { class: "modal-content" }
const _hoisted_158 = { class: "modal-header" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Tukar Status Urusan", -1)
const _hoisted_160 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, "Adakah Anda ingin Menukar Status Urusan?", -1)
const _hoisted_161 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_VueSelect = _resolveComponent("VueSelect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PenyediaanModal = _resolveComponent("PenyediaanModal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Form, {
            class: "mx-auto w-100 pt-1",
            novalidate: "novalidate",
            id: "penyediaan_form"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, [
                            _withDirectives(_createElementVNode("select", {
                              id: "statusDropdown",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.status) = $event)),
                              class: "form-select"
                            }, [
                              (_ctx.akauntan == true)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_14,
                                    _hoisted_15
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_16,
                                    _hoisted_17,
                                    _hoisted_18,
                                    _hoisted_19
                                  ], 64))
                            ], 512), [
                              [_vModelSelect, _ctx.data.status]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("input", {
                            type: "radio",
                            class: "btn-check",
                            name: "jenisType",
                            value: "pemangkuan",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (
                          (_ctx.tetapan = true),
                            (_ctx.targetData.kategori_permohonan = 'PMK')
                        )),
                            checked: _ctx.tetapan,
                            id: "pemangkuan"
                          }, null, 8, _hoisted_22),
                          _hoisted_23
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("input", {
                            type: "radio",
                            class: "btn-check",
                            name: "jenisType",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (
                          (_ctx.tetapan = false),
                          (_ctx.targetData.kategori_permohonan = 'KNP'),
                          (_ctx.akauntan = false)
                        )),
                            id: "kenaikan",
                            checked: !_ctx.tetapan
                          }, null, 8, _hoisted_25),
                          _hoisted_26
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          (_ctx.tetapan == true)
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 0,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetData.jenis_permohonan) = $event)),
                                class: "form-select mb-2",
                                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onJenisPermohonanChange()))
                              }, [
                                _hoisted_30,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(/*jenisDataPMK*/ _ctx.opsiSkimPemangkuan, (item, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: index,
                                    value: item.value
                                  }, _toDisplayString(item.label), 9, _hoisted_31))
                                }), 128))
                              ], 544)), [
                                [_vModelSelect, _ctx.targetData.jenis_permohonan]
                              ])
                            : _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 1,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.targetData.jenis_permohonan) = $event)),
                                class: "form-select mb-2",
                                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onJenisPermohonanChange()))
                              }, [
                                _hoisted_32,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(/*jenisDataKNP*/ _ctx.opsiSkimKenaikanPangkat, (item, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: index,
                                    value: item.value
                                  }, _toDisplayString(item.label), 9, _hoisted_33))
                                }), 128))
                              ], 544)), [
                                [_vModelSelect, _ctx.targetData.jenis_permohonan]
                              ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _hoisted_39,
                              _withDirectives(_createVNode(_component_datepicker, {
                                id: "tarikhKriteriaMula",
                                name: "tarikhKriteriaMula",
                                modelValue: _ctx.data.tarikh_kriteria_mula,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.data.tarikh_kriteria_mula) = $event)),
                                placeholder: "DD-MM-YYYY",
                                textInput: "",
                                autoApply: "",
                                enableTimePicker: false,
                                maxDate: 
                              _ctx.data.tarikh_kriteria_akhir
                                ? new Date(_ctx.data.tarikh_kriteria_akhir)
                                : ''
                            ,
                                format: "dd-MM-yyyy"
                              }, null, 8, ["modelValue", "maxDate"]), [
                                [_directive_maska, '##-##-####']
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _hoisted_41,
                              _withDirectives(_createVNode(_component_datepicker, {
                                id: "tarikhKriteriaTamat",
                                name: "tarikhKriteriaTamat",
                                modelValue: _ctx.data.tarikh_kriteria_akhir,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.data.tarikh_kriteria_akhir) = $event)),
                                placeholder: "DD-MM-YYYY",
                                textInput: "",
                                autoApply: "",
                                enableTimePicker: false,
                                minDate: 
                              _ctx.data.tarikh_kriteria_mula
                                ? new Date(_ctx.data.tarikh_kriteria_mula)
                                : ''
                            ,
                                format: "dd-MM-yyyy"
                              }, null, 8, ["modelValue", "minDate"]), [
                                [_directive_maska, '##-##-####']
                              ])
                            ])
                          ]),
                          _hoisted_42
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _hoisted_48,
                              (_ctx.targetData.jenis_permohonan == 'IKHTISAS')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_49, [
                                    _withDirectives(_createVNode(_component_datepicker, {
                                      name: "tarikhPermohonanMula",
                                      id: "tarikhPermohonanMula",
                                      modelValue: _ctx.data.tarikh_permohonan_mula,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.data.tarikh_permohonan_mula) = $event)),
                                      placeholder: "DD-MM-YYYY",
                                      textInput: "",
                                      autoApply: "",
                                      enableTimePicker: false,
                                      minDate: new Date(),
                                      maxDate: 
                                _ctx.data.tarikh_permohonan_tamat
                                  ? new Date(_ctx.data.tarikh_permohonan_tamat)
                                  : ''
                              ,
                                      format: "dd-MM-yyyy",
                                      disabled: true
                                    }, null, 8, ["modelValue", "minDate", "maxDate"]), [
                                      [_directive_maska, '##-##-####']
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("i", _hoisted_50, [
                                    _withDirectives(_createVNode(_component_datepicker, {
                                      name: "tarikhPermohonanMula",
                                      id: "tarikhPermohonanMula",
                                      modelValue: _ctx.data.tarikh_permohonan_mula,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.data.tarikh_permohonan_mula) = $event)),
                                      placeholder: "DD-MM-YYYY",
                                      textInput: "",
                                      autoApply: "",
                                      enableTimePicker: false,
                                      minDate: new Date(),
                                      maxDate: 
                                _ctx.data.tarikh_permohonan_tamat
                                  ? new Date(_ctx.data.tarikh_permohonan_tamat)
                                  : ''
                              ,
                                      format: "dd-MM-yyyy"
                                    }, null, 8, ["modelValue", "minDate", "maxDate"]), [
                                      [_directive_maska, '##-##-####']
                                    ])
                                  ]))
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _hoisted_52,
                              (_ctx.targetData.jenis_permohonan == 'IKHTISAS')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_53, [
                                    _withDirectives(_createVNode(_component_datepicker, {
                                      id: "tarikhPermohonanTamat",
                                      name: "tarikhPermohonanTamat",
                                      modelValue: _ctx.data.tarikh_permohonan_tamat,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.data.tarikh_permohonan_tamat) = $event)),
                                      placeholder: "DD-MM-YYYY",
                                      textInput: "",
                                      autoApply: "",
                                      enableTimePicker: false,
                                      minDate: 
                                _ctx.data.tarikh_permohonan_mula
                                  ? new Date(_ctx.data.tarikh_permohonan_mula)
                                  : new Date()
                              ,
                                      format: "dd-MM-yyyy",
                                      disabled: true
                                    }, null, 8, ["modelValue", "minDate"]), [
                                      [_directive_maska, '##-##-####']
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("i", _hoisted_54, [
                                    _withDirectives(_createVNode(_component_datepicker, {
                                      id: "tarikhPermohonanTamat",
                                      name: "tarikhPermohonanTamat",
                                      modelValue: _ctx.data.tarikh_permohonan_tamat,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.data.tarikh_permohonan_tamat) = $event)),
                                      placeholder: "DD-MM-YYYY",
                                      textInput: "",
                                      autoApply: "",
                                      enableTimePicker: false,
                                      minDate: 
                                _ctx.data.tarikh_permohonan_mula
                                  ? new Date(_ctx.data.tarikh_permohonan_mula)
                                  : new Date()
                              ,
                                      format: "dd-MM-yyyy"
                                    }, null, 8, ["modelValue", "minDate"]), [
                                      [_directive_maska, '##-##-####']
                                    ])
                                  ]))
                            ])
                          ]),
                          _hoisted_55
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _hoisted_58,
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                              _hoisted_61,
                              _withDirectives(_createVNode(_component_datepicker, {
                                name: "markah_lnpt_tahun_mula",
                                id: "markah_lnpt_tahun_mula",
                                modelValue: _ctx.data.markah_lnpt_tahun_mula,
                                "onUpdate:modelValue": [
                                  _cache[13] || (_cache[13] = ($event: any) => ((_ctx.data.markah_lnpt_tahun_mula) = $event)),
                                  _ctx.handleTahunMulaChange
                                ],
                                placeholder: "YYYY",
                                textInput: "",
                                autoApply: "",
                                yearPicker: "",
                                format: "yyyy",
                                maxDate: _ctx.maxDateForTahunMula(),
                                clearable: ""
                              }, null, 8, ["modelValue", "maxDate", "onUpdate:modelValue"]), [
                                [_directive_maska, '####']
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                              _hoisted_63,
                              _withDirectives(_createVNode(_component_datepicker, {
                                id: "markah_lnpt_tahun_akhir",
                                name: "markah_lnpt_tahun_akhir",
                                modelValue: _ctx.data.markah_lnpt_tahun_akhir,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.data.markah_lnpt_tahun_akhir) = $event)),
                                placeholder: "YYYY",
                                textInput: "",
                                autoApply: "",
                                yearPicker: "",
                                format: "yyyy",
                                maxDate: new Date(),
                                clearable: ""
                              }, null, 8, ["modelValue", "maxDate"]), [
                                [_directive_maska, '####']
                              ])
                            ])
                          ]),
                          _hoisted_64
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _createElementVNode("div", _hoisted_67, [
                          _hoisted_68,
                          (_ctx.tetapan == true)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                class: "form-check-input",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.lokasi) = $event)),
                                name: "sich",
                                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.clearArray && _ctx.clearArray(...args))),
                                disabled: 
                          _ctx.targetData.jenis_permohonan == 'IKHTISAS'
                            ? true
                            : false
                        
                              }, null, 8, _hoisted_69)), [
                                [_vModelCheckbox, _ctx.lokasi]
                              ])
                            : (_openBlock(), _createElementBlock("input", _hoisted_70)),
                          _hoisted_71
                        ])
                      ]),
                      (_ctx.lokasi)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                            _createElementVNode("div", _hoisted_73, [
                              _hoisted_74,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedNegeriDaerah, (negeriDaerah, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "d-flex mb-2",
                                  key: negeriDaerah.key
                                }, [
                                  _createElementVNode("div", _hoisted_75, [
                                    _withDirectives(_createElementVNode("select", {
                                      class: "form-select",
                                      "onUpdate:modelValue": ($event: any) => ((negeriDaerah.negeri) = $event),
                                      "data-control": "select2"
                                    }, [
                                      _hoisted_77,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combo.negeri, (item, index) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: index,
                                          value: item.value
                                        }, _toDisplayString(item.label), 9, _hoisted_78))
                                      }), 128))
                                    ], 8, _hoisted_76), [
                                      [_vModelSelect, negeriDaerah.negeri]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_79, [
                                    _createVNode(_component_VueSelect, {
                                      options: _ctx.optDaerahFilteredByNegeri(negeriDaerah.negeri),
                                      label: "nama_daerah",
                                      modelValue: negeriDaerah.daerah,
                                      "onUpdate:modelValue": ($event: any) => ((negeriDaerah.daerah) = $event),
                                      style: {}
                                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  (index > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                        _createElementVNode("button", {
                                          class: "btn btn-danger",
                                          onClick: ($event: any) => (_ctx.removeLokasiPenempatanField(negeriDaerah))
                                        }, " - ", 8, _hoisted_81)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              (_ctx.secondDropdownIsOpen)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                    _createElementVNode("div", _hoisted_83, [
                                      _withDirectives(_createElementVNode("select", {
                                        class: "form-select",
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedNegeri2) = $event)),
                                        "data-control": "select2"
                                      }, [
                                        _hoisted_84,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combo.negeri, (item, index) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: index,
                                            value: item.value
                                          }, _toDisplayString(item.label), 9, _hoisted_85))
                                        }), 128))
                                      ], 512), [
                                        [_vModelSelect, _ctx.selectedNegeri2]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_86, [
                                      _createElementVNode("div", _hoisted_87, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.searchDaerah2) = $event)),
                                          class: "form-control",
                                          placeholder: "Taip Daerah",
                                          onFocus: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleFocus2 && _ctx.handleFocus2(...args))),
                                          onInput: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.handleInput2 && _ctx.handleInput2(...args))),
                                          style: {"padding-right":"30px"}
                                        }, null, 544), [
                                          [_vModelText, _ctx.searchDaerah2]
                                        ]),
                                        _hoisted_88
                                      ]),
                                      _withDirectives(_createElementVNode("input", {
                                        type: "hidden",
                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selectedDaerah2) = $event)),
                                        name: "daerah2"
                                      }, null, 512), [
                                        [_vModelText, _ctx.selectedDaerah2]
                                      ]),
                                      _withDirectives(_createElementVNode("div", _hoisted_89, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDaerah2, (item) => {
                                          return (_openBlock(), _createElementBlock("a", {
                                            class: "dropdown-item",
                                            key: item.id,
                                            onClick: ($event: any) => (_ctx.selectDaerah2(item))
                                          }, _toDisplayString(item.nama_daerah), 9, _hoisted_90))
                                        }), 128))
                                      ], 512), [
                                        [_vShow, _ctx.state2.isOpen && _ctx.filteredDaerah2.length > 0]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_91, [
                                _createElementVNode("a", {
                                  onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (
                            /*displaySecondDropdown*/
                            _ctx.addLokasiPenempatanField()
                          ), ["stop"])),
                                  class: "btn btn-primary",
                                  style: {"margin-right":"0.5rem"}
                                }, "Add Item")
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_92, [
                        _hoisted_93,
                        _createElementVNode("div", _hoisted_94, [
                          _hoisted_95,
                          _createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            value: "",
                            name: "hantarNotifikasi",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.notifikasi = !_ctx.notifikasi)),
                            disabled: 
                          _ctx.targetData.jenis_permohonan == 'IKHTISAS' ||
                          _ctx.targetData.jenis_permohonan == 'PRO'
                            ? true
                            : false
                        
                          }, null, 8, _hoisted_96),
                          _hoisted_97
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _hoisted_102,
                      _hoisted_103,
                      _hoisted_104,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "tajuk",
                        class: "form-control mb-2",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.data.tajuk) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.data.tajuk]
                      ]),
                      _createElementVNode("div", _hoisted_105, [
                        _hoisted_106,
                        _createElementVNode("div", _hoisted_107, [
                          _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.data.jenis_permohonan), 1)
                        ])
                      ]),
                      _hoisted_109,
                      _createElementVNode("div", _hoisted_110, [
                        _hoisted_111,
                        _createElementVNode("div", _hoisted_112, [
                          _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.formatDate(_ctx.data.tarikh_kriteria_mula)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.data.tarikh_kriteria_akhir)), 1)
                        ])
                      ]),
                      _hoisted_114,
                      _createElementVNode("div", _hoisted_115, [
                        _hoisted_116,
                        _createElementVNode("div", _hoisted_117, [
                          _createElementVNode("span", _hoisted_118, _toDisplayString(_ctx.calonList.length), 1),
                          _hoisted_119
                        ])
                      ]),
                      _hoisted_120,
                      _createElementVNode("div", _hoisted_121, [
                        _hoisted_122,
                        _createElementVNode("div", _hoisted_123, [
                          _createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.formatDate(_ctx.data.tarikh_permohonan_mula)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.data.tarikh_permohonan_tamat)), 1)
                        ])
                      ]),
                      _hoisted_125,
                      _createElementVNode("div", _hoisted_126, [
                        _hoisted_127,
                        _createElementVNode("div", _hoisted_128, [
                          _createElementVNode("span", _hoisted_129, _toDisplayString(_ctx.data.markah_lnpt_tahun_mula) + " - " + _toDisplayString(_ctx.data.markah_lnpt_tahun_akhir), 1)
                        ])
                      ]),
                      _hoisted_130,
                      _createElementVNode("div", _hoisted_131, [
                        _hoisted_132,
                        _createElementVNode("div", _hoisted_133, [
                          (_ctx.lokasi)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_134, "Ya"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_135, "Tidak"))
                        ])
                      ]),
                      (_ctx.lokasi)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                            _hoisted_137,
                            _createElementVNode("div", _hoisted_138, [
                              _createElementVNode("div", _hoisted_139, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedNegeriDaerah, (negeriDaerah, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "mb-2",
                                    key: negeriDaerah.key
                                  }, [
                                    _createElementVNode("span", null, "Negeri " + _toDisplayString(index + 1) + ": " + _toDisplayString(_ctx.findLabel(negeriDaerah.negeri, _ctx.combo.negeri)), 1)
                                  ]))
                                }), 128))
                              ]),
                              _createElementVNode("div", _hoisted_140, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedNegeriDaerah, (negeriDaerah, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "mb-2",
                                    key: negeriDaerah.key
                                  }, [
                                    _createElementVNode("span", null, "Daerah " + _toDisplayString(1 + index) + ": " + _toDisplayString(negeriDaerah.daerah.nama_daerah || ""), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_141,
                      _createElementVNode("div", _hoisted_142, [
                        _hoisted_143,
                        _createElementVNode("div", _hoisted_144, [
                          (_ctx.notifikasi)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_145, "Ya"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_146, "Tidak"))
                        ])
                      ]),
                      _hoisted_147
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_148, [
                _createElementVNode("div", _hoisted_149, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-light-primary me-3",
                    "data-kt-stepper-action": "previous",
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.previousStep()))
                  }, [
                    _createElementVNode("span", _hoisted_150, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr063.svg" })
                    ]),
                    _createTextVNode(" Sebelum ")
                  ])
                ]),
                _createElementVNode("div", null, [
                  (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-lg btn-primary mb-5",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.formSubmit()))
                      }, [
                        _createElementVNode("span", _hoisted_151, [
                          _createTextVNode(" Simpan "),
                          _createElementVNode("span", _hoisted_152, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]),
                        _hoisted_153
                      ]))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args))),
                        class: "btn btn-lg btn-primary mb-5"
                      }, [
                        _createTextVNode(" Seterusnya "),
                        _createElementVNode("span", _hoisted_154, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                ])
              ])
            ]),
            _: 1
          })
        ])
      ], 512),
      (_ctx.showModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
            _createElementVNode("div", _hoisted_156, [
              _createElementVNode("div", _hoisted_157, [
                _createElementVNode("div", _hoisted_158, [
                  _hoisted_159,
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showModal = false))
                  }, " × ")
                ]),
                _hoisted_160,
                _createElementVNode("div", _hoisted_161, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-success",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.changeStatus('AKTIF')))
                  }, " AKTIF "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.changeStatus('TIDAK AKTIF')))
                  }, " TIDAK AKTIF ")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_PenyediaanModal, { calonData: _ctx.calonList }, null, 8, ["calonData"])
  ], 64))
}